import React from "react";

interface ButtonProps extends React.HtmlHTMLAttributes<HTMLButtonElement> {
  bgColor?: string
  textColor?: string
  bgHoverColor?: string
  textHoverColor?: string
  effect?: "pixel" | undefined
};

const Button = (props: ButtonProps) => {
  const newStyle = {
    outline: "none",
    border: "none",
    ...props.style
  } as React.CSSProperties
  const newProps = {
    ...props,
    style: newStyle
  }
  return (
    <button  {...newProps}></button>
  )
}

export default Button;
